import { render, staticRenderFns } from "./Novidades.vue?vue&type=template&id=29258000&scoped=true&"
import script from "./Novidades.vue?vue&type=script&lang=js&"
export * from "./Novidades.vue?vue&type=script&lang=js&"
import style0 from "./style.scss?vue&type=style&index=0&id=29258000&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29258000",
  null
  
)

export default component.exports